import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { Form } from 'antd';
import BtnBlock from './components/BtnBlock';
import NameField from './components/NameField';
import ModalWindows from './components/ModalWindows';
import {
	EditVideoStudioContext,
	IEditVideoStudioContext,
} from './editVideoStudioModalContext/editVideoStudioModalState/editVideoStudioModalContext';
import { preventDefaultForEnterKey } from 'utils/helpers';
import classNames from 'classnames';
import style from './EditVideoStudioModal.module.scss';

interface IEditVideoStudioModal {
	isVisible: boolean;
}

const EditVideoStudioModal: React.FC<IEditVideoStudioModal> = ({ isVisible }) => {
	const { setDataForSubmit, changeTypeOfModalWindow, changeName, studioID, name } =
		useContext<IEditVideoStudioContext>(EditVideoStudioContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ name });
	}, [name]);

	const submit = () => {
		setDataForSubmit({
			id: studioID,
			name,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={containerClasses} data-test="EditVideoStudioModal">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.wrapper}>
					<div className={style.content}>
						<Text
							className={style.heading}
							translationNameSpace="form"
							translationKey="editingVideoStudioHeading"
							size="xxl"
							weight="bold"
						/>
						<NameField changeName={changeName} />
					</div>
					<BtnBlock />
				</div>
			</Form>
			<ModalWindows />
		</div>
	);
};

export default React.memo(EditVideoStudioModal);
